import ButtonGroupCustomized from '@/components/ButtonGroupCustomized'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'
import InternalInformationContent from './InternalInformationContent'
import {
    DocumentGroup,
    DocumentGroupHrCulture,
    DocumentGroupProcedureGuide,
    DocumentGroupLegalAdmin,
} from '@/modules/Asset/constants'

// Filter only the 3 groups we want
const DISPLAY_GROUPS = [
    DocumentGroupHrCulture,
    DocumentGroupProcedureGuide,
    DocumentGroupLegalAdmin,
]

const InternalInformation: React.FC = () => {
    const { t } = useTranslation('dashboard')

    const [activeTab, setActiveTab] = useState<DocumentGroup>(
        DocumentGroupHrCulture
    )

    const tabs = DISPLAY_GROUPS.map((group) => {
        return {
            key: group,
            label: t(`asset:document_groups.${group}`),
        }
    })

    return (
        <div className="space-y-3">
            {/* Header */}
            <div className="flex items-center justify-between">
                <Typogaphy className="font-semibold text-base text-primary">
                    {t('internal_information.title')}
                </Typogaphy>
            </div>

            {/* Tab Navigation */}
            <ButtonGroupCustomized
                className="p-2"
                active={activeTab}
                onChange={(value) => setActiveTab(value as DocumentGroup)}
                buttons={tabs.map((tab) => ({
                    label: tab.label,
                    value: tab.key,
                }))}
            />

            {/* Content Area */}
            <InternalInformationContent group={activeTab} />
        </div>
    )
}

export default InternalInformation
